import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../../Providers/AuthProvider'

const InvoiceDataCard = ({ invoiceData }) => {
  const { t } = useTranslation()
  const { authState } = useAuth()
  const customerData = authState.user.isOperator ? authState.selectedCustomerData : authState.user.customerInfo[0]

  return (
    <div>
      <div className='row justify-content-center'>
        <div className='justify-content-center mt-2'>
          <div>
            <div className='panel-header-title'>{t('invoice_details')}</div>
            <div className='col-auto ms-1'>
              {customerData.fullName} <br />
              <br />
              {customerData.street} {customerData.houseNum} {customerData.localNum.trim() ? '/' + customerData.localNum : ''} <br />
              {customerData.zipCode} {customerData.city} <br />
              {invoiceData.taxId ? 'NIP: ' + invoiceData.taxId : ''}<br />
              {invoiceData.regon ? 'Regon: ' + invoiceData.regon : ''}<br />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InvoiceDataCard